(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    
  class StickyAddToCart extends HTMLElement {
    connectedCallback() {
      this.action = this.querySelector('[ref="action"]');
      this.stickyButton = this.querySelector('[ref="button"]');
      this.priceTarget = this.querySelector('[ref="price"]');
      this.variantTarget = this.querySelector('[ref="variant"]');
      this.displayMode = this.dataset.displayMode || 'after_atc';

      try {
        this.variantData = JSON.parse(this.querySelector('[ref="variantData"]').textContent);
      } catch (error) {
        this.variantData = {};
      }

      this.realButton = this.findRealButton();
      if (!this.realButton) return;

      this.buildClone();

      if (this.displayMode === 'always') {
        /* Shown from page load, no scroll trigger. */
        this.classList.add('is-visible');
      } else {
        const offset = parseInt(this.dataset.offset, 10) || 0;

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              /* Only show once the real button has been scrolled PAST (it sits above
                 the viewport). While it's still below the fold the bar stays hidden. */
              const limit = entry.rootBounds ? entry.rootBounds.top : -offset;
              const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.bottom <= limit;
              this.classList.toggle('is-visible', scrolledPast);
            });
          },
          { rootMargin: `${offset}px 0px 0px 0px` }
        );
        this.observer.observe(this.realButton);
      }

      this.scope = document.querySelector('.product-details') || document.body;

      this.mutationObserver = new MutationObserver(() => this.sync());
      this.mutationObserver.observe(this.scope, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['disabled', 'class', 'value', 'checked', 'selected'],
      });

      this.onChange = () => setTimeout(() => this.sync(), 50);
      document.addEventListener('change', this.onChange);

      this.sync();
    }

    /* Clones the theme's real button so the sticky bar uses identical markup and classes. */
    buildClone() {
      const clone = this.realButton.cloneNode(true);

      clone.type = 'button';
      ['id', 'name', 'form', 'ref', 'value'].forEach((attr) => clone.removeAttribute(attr));
      clone.querySelectorAll('[id], [ref]').forEach((el) => {
        el.removeAttribute('id');
        el.removeAttribute('ref');
      });
      clone.classList.add('sticky-atc__button');

      clone.addEventListener('click', (event) => {
        event.preventDefault();
        this.findRealButton()?.click();
      });

      this.stickyButton.replaceWith(clone);
      this.stickyButton = clone;
    }

    findRealButton() {
      return document.querySelector(
        'add-to-cart-component button[type="submit"],' +
        'product-form-component button[type="submit"],' +
        '.product-form__buttons button[type="submit"],' +
        'form[action*="/cart/add"] button[type="submit"]'
      );
    }

    currentVariantId() {
      const input = document.querySelector('form[action*="/cart/add"] [name="id"]');
      return input ? input.value : null;
    }

    sync() {
      const button = this.findRealButton();

      if (button) {
        if (button !== this.realButton) {
          this.observer?.unobserve(this.realButton);
          this.realButton = button;
          this.observer?.observe(this.realButton);
        }

        this.stickyButton.disabled = button.disabled;

        if (this.stickyButton.innerHTML !== button.innerHTML) {
          this.stickyButton.innerHTML = button.innerHTML;
        }

        const classes = `${button.className} sticky-atc__button`;
        if (this.stickyButton.className !== classes) {
          this.stickyButton.className = classes;
        }
      }

      const variant = this.variantData[this.currentVariantId()];
      if (!variant) return;

      if (this.variantTarget) this.variantTarget.textContent = variant.title;
      if (this.priceTarget) this.priceTarget.textContent = variant.price;
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.mutationObserver?.disconnect();
      document.removeEventListener('change', this.onChange);
    }
  }

  if (!customElements.get('sticky-add-to-cart')) {
    customElements.define('sticky-add-to-cart', StickyAddToCart);
  }

  } catch(e) { console.error(e); }
})();
})();
